export * from './offerBodyProduct';
